import {AbstractValidator, ValidationOptions} from "@ha/formhandler";
import {DateTime} from "luxon";

type MilestoneDateTimes = {
    start: DateTime;
    end?: DateTime;
}

export class MilestoneStartBeforeEndValidator extends AbstractValidator<MilestoneDateTimes, ValidationOptions<MilestoneDateTimes>> {

    protected get defaultValidationMessage(): string {
        return `Start must be before end.`;
    }

    protected validate(milestone: MilestoneDateTimes): boolean {
        const {start, end} = milestone;

        if (end === undefined) {
            return true;
        }

        return start <= end;
    }

}